import type { ReactNode } from 'react'

/**
 * PageHeader — consistent top-bar used by every page.
 *
 * Phase 2 changes:
 *  - Bottom separator border to visually anchor the header
 *  - Larger, bolder title (22px font-black tracking-tight)
 *  - Slightly taller subtitle for breathing room
 */
interface PageHeaderProps {
  dark: boolean
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ dark, title, subtitle, actions }: PageHeaderProps) {
  const mainTxt  = dark ? 'text-slate-50'  : 'text-slate-900'
  const mutedTxt = dark ? 'text-slate-400' : 'text-slate-500'
  const border   = dark ? 'border-white/8' : 'border-slate-200'

  return (
    <div className={`flex items-center justify-between gap-3 flex-wrap pb-4 border-b ${border}`}>
      <div>
        <div className={`text-[22px] font-black tracking-tight leading-tight ${mainTxt}`}>
          {title}
        </div>
        {subtitle && (
          <div className={`text-[12px] mt-1.5 ${mutedTxt}`}>
            {subtitle}
          </div>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap">
          {actions}
        </div>
      )}
    </div>
  )
}
